import { memo } from 'react';
import { Box } from '@mui/material';
import { useReactiveVar } from '@apollo/client';

import { usePersistentCartItems } from 'store/cartItems';
import { productFlatListVar } from 'store/productsFlatList';
import theme from 'src/style-system/theme';

import DishDisplay from '@components/DishDisplay';
import NewDishDisplay from '@components/NewDishDisplay';
import { useElevar } from '@utils/elevar';

interface ISelectedDishDisplayProps {
  isFinalOrder?: boolean;
  isSmallSize?: boolean;
  justifyContent?: string;
  alignItems?: string;
  columnGap?: number;
  rowGap: number;
  isNoAddMealBtn?: boolean;
  isOverflowOnMobile?: boolean;
  isNewDishDisplay?: boolean;
  sidesIncluded?: boolean;
  isDisplaySides?: boolean;
  mode?: string;
}

const SelectedDishDisplay = ({
  isFinalOrder = false,
  isSmallSize = false,
  justifyContent,
  alignItems,
  columnGap = 10,
  rowGap,
  isNoAddMealBtn = false,
  isOverflowOnMobile = false,
  isNewDishDisplay = false,
  sidesIncluded = true,
  isDisplaySides = false,
  mode,
}: ISelectedDishDisplayProps) => {
  const {
    elevarAddToCartEvent,
    elevarRemoveFromCartEvent,
    elevarViewItemEvent,
  } = useElevar();
  const cartItems = usePersistentCartItems();
  const { productFlatList } = useReactiveVar(productFlatListVar);

  if (isNewDishDisplay) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: alignItems || 'center',
          justifyContent: justifyContent || 'flex-start',
          columnGap: `${columnGap}px`,
          rowGap: `${rowGap}px`,
          [theme.breakpoints.down(750)]: {
            width: '100%',
          },
        }}
      >
        {productFlatList &&
          Object.keys(cartItems)?.map((items: string) => {
            if (productFlatList[+items]?.isActive) {
              if (
                sidesIncluded ||
                (!sidesIncluded && !productFlatList[+items]?.unitsPerSide)
              ) {
                return (
                  <NewDishDisplay
                    product={productFlatList[+items]}
                    key={items}
                    mode={mode}
                    elevarAddToCartEvent={elevarAddToCartEvent}
                    elevarRemoveFromCartEvent={elevarRemoveFromCartEvent}
                    elevarViewItemEvent={elevarViewItemEvent}
                  />
                );
              }
            }
          })}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: alignItems || 'center',
        justifyContent: justifyContent || 'flex-start',
        flexWrap: 'wrap',
        columnGap: `${columnGap}px`,
        rowGap: `${rowGap}px`,
        [theme.breakpoints.down(750)]: {
          width: '100%',
          flexWrap: isOverflowOnMobile ? 'nowrap' : 'wrap',
          overflowX: 'auto',
        },
      }}
    >
      {isDisplaySides
        ? productFlatList &&
          Object.keys(cartItems)?.map((items: string) => {
            if (
              productFlatList[+items]?.isActive &&
              productFlatList[+items]?.unitsPerSide
            ) {
              return (
                <DishDisplay
                  product={productFlatList[+items]}
                  key={items}
                  isFinalOrder={isFinalOrder}
                  isSmallSize={isSmallSize}
                  isNoAddMealBtn={isNoAddMealBtn}
                  mode={mode}
                  elevarAddToCartEvent={elevarAddToCartEvent}
                  elevarRemoveFromCartEvent={elevarRemoveFromCartEvent}
                  elevarViewItemEvent={elevarViewItemEvent}
                />
              );
            }
          })
        : productFlatList &&
          Object.keys(cartItems)?.map((items: string) => {
            if (
              productFlatList[+items]?.isActive &&
              (sidesIncluded ||
                (!productFlatList[+items]?.unitsPerSide && !sidesIncluded))
            ) {
              return (
                <DishDisplay
                  product={productFlatList[+items]}
                  key={items}
                  isFinalOrder={isFinalOrder}
                  isSmallSize={isSmallSize}
                  isNoAddMealBtn={isNoAddMealBtn}
                  mode={mode}
                  elevarAddToCartEvent={elevarAddToCartEvent}
                  elevarRemoveFromCartEvent={elevarRemoveFromCartEvent}
                  elevarViewItemEvent={elevarViewItemEvent}
                />
              );
            }
          })}
    </Box>
  );
};

export default memo(SelectedDishDisplay);
